import React, {useContext, useRef, useState} from 'react';
import TemplateDefault from "../../../components/template-default";
import {useNavigate, useParams} from "react-router-dom";
import Card from "../../../components/card";
import InputDateTime from "../../../components/input-datetime";
import SelectComponent from "../../../components/select-component";
import Button from "../../../components/button";
import {toast} from "react-toastify";
import {AlertMessage} from "../../../utils/alert-message";
import AfterSaleService from "../../../services/after-sale-service";
import MySwal from "sweetalert2";
import {useQuery} from "@tanstack/react-query";
import projectService from "../../../services/project-service";
import requestService from "../../../services/request-service";
import moment from "moment/moment";
import afterSaleService from "../../../services/after-sale-service";
import general from "../../../utils/general";
import ModalRequest from "../../software-attendances/components/modal-request";
import {ProjectContext} from "../../../context/project-context";
import InputForm from "../../../components/input-form";
import InputRadio from "../../../components/input-radio";
import userService from "../../../services/user-service";
import FormField from "../../../components/react-hook-form/form-field";
import inputText from "../../../components/input-text";
import {FormProvider, useForm} from "react-hook-form";
import TextCorrectorComponent from "../../../components/text-corrector-component";

const difficultOpt = [
    {value: "Estrutura" , label: "Estrutura"},
    {value: "Contingente" , label: "Contingente"},
    {value: "Rotatividade" , label: "Rotatividade de contingente"},
    {value: "Usabilidade" , label: "Usabilidade"},
    {value: "Outro" , label: "Outro"}
]

const initialState = {
    date: new Date(),
    project: [],
    attendances: [],
    description: "",
    title: "",
    requester: [],
    difficult: "",
    duration: null,
    in_person: false,
    remote: false,
    poc: false,
    other: ""
}
const AfterSaleForm = () => {
    const navigate = useNavigate();
    const {user} = useContext(ProjectContext);
    const {id} = useParams();
    const [state, setState] = useState(initialState)
    const [request, setRequest] = useState(null)
    const [openModal, setOpenModal] = useState(false);
    const [solicitationGroups, setsolicitationGroups] = useState([])
    const [requests, setRequests] = useState([])
    const [requesterOpt, setRequesterOpt] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const attachesRef = useRef();

    const { data: projects } = useQuery({
        queryFn: () => projectService.options().then(({data}) => data),
        queryKey: ["projects"]
    });

    const { data: attendancesOpt } = useQuery({
        queryFn: () => afterSaleService.getAttendances().then(({data}) => data),
        queryKey: ["attendances"]
    });

    useQuery({
        queryFn: () => userService.getMultiRequesters(state.project.map(a => a.value)).then(({data}) => {
            setRequesterOpt(data)
            return data
        }),
        queryKey: ["requesters", state.project],
        enabled: !!state.project
    });

    const handleDateInput = (value, name) => setState(prev => ({...prev, [name]: value}));
    const handleSelect = (id, value) => setState(prev => ({ ...prev, [id]: value }));
    const handleInput = ({target: {value, name}}) => setState(prev => ({...prev, [name]: value}));

    const handleAttendanceType = (name) => {
        setState(prev => {
            const isSelected = !!prev[name];

            if (isSelected) {
                return {...prev, [name]: false};
            }

            const next = {
                ...prev,
                in_person: name === "in_person",
                remote: name === "remote",
                poc: name === "poc",
            };

            if (name === "poc") {
                return {
                    ...next,
                    project: [],
                    requester: [],
                    difficult: "",
                    other: "",
                };
            }

            return next;
        });
    }
    const {isFetching, refetch} = useQuery({
        queryFn: () => afterSaleService.getById(id).then(({data}) => {
            const {created_at, user_creation_login, updated_at, user_update_login} = data
            const title = `Cadastrado em ${general.formatDate(created_at)} por ${user_creation_login} - Última atualização em ${general.formatDate(updated_at)} por ${user_update_login}`;
            console.log(data.duration)
            if (data.duration === 0.00) data.duration = null
            setState({
                date: data.date,
                project: projects.filter(p => data.afterSaleProjects.includes(p.value)),
                attendances: data.attendances,
                description: data.description,
                module: data.module,
                responsible: user.name,
                title,
                requester: data.requester,
                difficult: difficultOpt.find(p => p.value === data.difficult),
                duration: data.duration,
                in_person: data.in_person,
                remote: data.remote,
                poc: !!data.poc,
                other: data.other
            })
            setRequests(data.requests_id ?? [])
            return [];
        }),
        queryKey: ['after-sale', id],
        enabled: !!id,
    });

    const saveWithRequest = (request) => {
        request.deadline = request.deadline ? general.formatDate(request.deadline) : null;
        request.requester = request.requester?.label ?? null
        submit(request);
    }

    const submit = (saveRequest = null) => {

        const dataRaw = methods.getValues();

        const formData = new FormData();

        const form = {
            date: state.date ? moment(state.date).format("YYYY-MM-DD hh:mm:ss") : "",
            projects: JSON.stringify(state.poc ? [] : state.project.map(a => a.value)),
            attendances: JSON.stringify(state.attendances.map(a => a.label)),
            description: dataRaw?.description ?? "",
            request: saveRequest ? JSON.stringify(saveRequest) : "",
            requester: JSON.stringify(state.poc ? [] : state.requester.map(a => a.label)),
            difficult: state.poc ? null : state.difficult ? state.difficult.value : null,
            duration: state.duration ?? 0,
            in_person: state.in_person ?? false,
            remote: state.remote ?? false,
            poc: state.poc ?? false,
            other: state.poc ? "" : state.other
        }

        const attachesRow = [];
        attachesRef.current?.api.forEachNode((node) => {
            attachesRow.push(node.data);

            if (node.data?.file) formData.append("attaches[]", node.data.file);
        });

        Object.keys(form).forEach(key => {
            formData.append(key, form[key])
        });

        formData.append("attachs", JSON.stringify(attachesRow));

        if (!!id) formData.append('_method', 'PUT');

        const response = !!id ? AfterSaleService.edit(formData, id) : AfterSaleService.create(formData);

        response
            .then(({ data }) => {
                toast.success("Salvo com sucesso.");
                setOpenModal(false);
                id ? refetch() : navigate(`/after-sales/attendances/form/${data.id}`);
            })
            .catch((err) => {
                const { data: { message } } = err.response;
                toast.error(AlertMessage[message] ?? "Não foi possível salvar");
            })
    }

    const deleteSale = () => {
        MySwal.fire({
            icon: "warning",
            title: "Excluir!",
            showCancelButton: true,
            text: "Tem certeza que deseja excluir atendimento?",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            confirmButtonColor: '#e64942',
            reverseButtons: true
        }).then(({ isConfirmed }) => {
            if (isConfirmed) {
                AfterSaleService.delete(id)
                    .then(() => {
                        navigate("/after-sales/attendances");
                    })
                    .catch((err) => {
                        const { data: { message } } = err.response;
                        toast.error(AlertMessage[message] ?? "Não foi possível excluir");
                    });
            }
        });
    }

    const modalGroups = () =>{
        setsolicitationGroups({
            id: "",
            deadline: "",
            title: "",
            description: "",
            groups: [],
            attachs: null
        })
    }

    const editRequest = (requestId) => {
        requestService.getById(requestId)
            .then(data => {
                setRequest(data);
                setOpenModal(true)
            })
    }

    const methods = useForm({
        values: state
    });

    return (
        <TemplateDefault title={"Cadastro de atendimento" + (id ? ` #${id}` : "")} isLoading={isLoading || isFetching}>
            <Card title={state.title} headerClass="text-center">
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">

                    <div className={"col-span-3"}>
                        <InputDateTime id={"date"} name={"date"} label={"Data *"}
                                       selected={state.date}
                                       onChange={(value) => handleDateInput(value, "date")}/>
                    </div>
                    <div className="col-span-3">
                        <InputForm id="duration" name="duration"
                                   label="Duração (Horas)"
                                   value={state.duration}
                                   col="col-span-12 lg:col-span-2" type="number" onChange={handleInput} />
                    </div>
                    <div className="col-span-3">
                        <SelectComponent
                            instanceId="attendances"
                            label="Atendente"
                            options={attendancesOpt ?? []}
                            value={state.attendances}
                            onChange={(value) => handleSelect("attendances", value)}
                            isMulti
                        />
                    </div>
                    <div className={"col-span-3 flex flex-wrap gap-x-8 gap-y-2"}>
                        <InputRadio
                            id={"in_person"}
                            name={"in_person"}
                            classNameLabel={"!text-[16px]"}
                            label={"Presencial"}
                            checked={state.in_person}
                            onChange={() => {}}
                            onClick={() => handleAttendanceType("in_person")}
                        />

                        <InputRadio
                            id={"remote"}
                            name={"remote"}
                            classNameLabel={"!text-[16px]"}
                            label={"Remoto"}
                            checked={state.remote}
                            onChange={() => {}}
                            onClick={() => handleAttendanceType("remote")}
                        />

                        <InputRadio
                            id={"poc"}
                            name={"poc"}
                            classNameLabel={"!text-[16px]"}
                            label={"POC"}
                            checked={state.poc}
                            onChange={() => {}}
                            onClick={() => handleAttendanceType("poc")}
                        />
                    </div>

                    <div className="col-span-3">
                        <SelectComponent
                            instanceId="project"
                            label="Projeto"
                            options={projects ?? []}
                            value={state.project}
                            onChange={(value) => handleSelect("project", value)}
                            isMulti
                            isDisabled={state.poc}
                        />
                    </div>
                    <div className="col-span-3">
                        <SelectComponent
                            instanceId="requester"
                            label="Solicitante"
                            options={requesterOpt ?? []}
                            value={state.requester}
                            onChange={(value) => handleSelect("requester", value)}
                            isMulti
                            isCreatable
                            formatCreateLabel={(inputValue) => `${inputValue}`}
                            isDisabled={state.poc}
                        />
                    </div>
                    <div className="col-span-3">
                        <SelectComponent
                            instanceId="difficult"
                            label="Dificuldades apontadas"
                            options={difficultOpt}
                            value={state.difficult}
                            onChange={(value) => handleSelect("difficult", value)}
                            isDisabled={state.poc}
                        />
                    </div>
                    {
                        state.difficult?.label === "Outro" && !state.poc &&
                            <div className={"col-span-3"}>
                                <InputForm id="other" name="other" label="Dificuldades apontadas" value={state.other} onChange={handleInput} />
                            </div>
                    }

                    <FormProvider {...methods}>
                        <div className={"col-span-12 space-y-4"}>
                            <TextCorrectorComponent setIsLoading={setIsLoading} setState={setState} name={"description"} module={"after_sale"} url={"/api/si/after-sales/text-correction"}>
                                <FormField
                                    as={inputText}
                                    name={"description"}
                                    label={"Descrição *"}
                                    height={"h-[calc(100vh-435px)]"}
                                    onChange={(e) => {
                                        const valor = e?.target?.value !== undefined ? e.target.value : e;

                                        setState(prev => ({ ...prev, description: valor }));
                                    }}
                                />
                            </TextCorrectorComponent>
                        </div>
                    </FormProvider>
                </div>

                <div className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-12 mt-4 items-center">
                    {
                        id &&
                        <>
                            <Button onClick={() => {setRequest(null); setOpenModal(true); modalGroups();}} target="primary" col={"col-span-2"}>
                                Gerar solicitação
                            </Button>
                            <div className={"col-span-10 flex items-center"}>
                                {
                                    requests.map((r, index) => {
                                        const match = r.match(/^(\d+)\(/);
                                        const number = match ? match[1] : null;
                                        return <p key={index} className={"text-lg hover:text-blue-700 hover:underline cursor-pointer mr-2"}
                                                  onClick={() => editRequest(number)}>#{r}</p>
                                    })
                                }

                            </div>
                        </>
                    }
                </div>
            </Card>

            <Card wrapperClass={"mt-4"}>
                <div className="flex justify-end flex-wrap gap-3">
                    {
                        id &&
                        <Button onClick={deleteSale} target="danger">
                            Excluir
                        </Button>
                    }
                    <Button onClick={() => navigate("/after-sales/attendances")} target="warning">
                        Cancelar
                    </Button>
                    <Button onClick={() => submit()} target="success">
                        Salvar
                    </Button>
                </div>
            </Card>

            {
                openModal &&
                <ModalRequest
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    attendance={state}
                    save={saveWithRequest}
                    request={request}
                    hasRequestPermission={true}
                    createGroups={solicitationGroups}
                    attachesRef={attachesRef}
                    software={false}
                    afterSale={true}
                    setIsLoading={setIsLoading}
                    correctorModule={"after_sale"}
                    correctorUrl={"/api/si/after-sales/text-correction"}
                />
            }
        </TemplateDefault>
    );
};

export default AfterSaleForm;
